"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  surchargeAndMiscellaneous: {
    title: 'Surcharge&Miscellaneous',
    exportExcel: 'Export',
    result: 'Result',
    supplement: '(Surcharges default payment term is CC or PP,but can change payment based on customer request.)',
    defaultPaidType: 'Only display the default payment method',
    por: 'POR',
    destination: 'Destination',
    del: 'DEL',
    costType: 'Freight Type',
    surcharge: 'surcharge',
    miscellaneous: 'miscellaneous',
    boxPile: 'Box Pile',
    containerType: 'Box Pile',
    cargoType: 'Cargo Type',
    paidType: 'Paid Type',
    pp: 'PP',
    cc: 'CC',
    chargeCode: 'Charge Code',
    rate: 'Rate',
    currency: 'Currency',
    transitClause: 'Transit Clause'
  }
};